export default __webpack_public_path__ + "static/media/thumb10_poster@2x.0e8dbf0c.png";